// Mutations
export const SET_FORM_VALIDATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.formValidation.data = payload
    state.formValidation.lastUpdate = new Date()
  }
}
export const ADD_FORM_VALIDATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.formValidation.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.formValidation.data.push(data)
      }
    })
  }
}
export const SET_FORM_VALIDATION_LOADING = (state, payload) => {
  state.formValidation.loading = payload
}

export const SET_INDICADORES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.indicadores.data = payload
    state.indicadores.lastUpdate = new Date()
  }
}
export const ADD_INDICADORES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.indicadores.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.indicadores.data.push(data)
      }
    })
  }
}
export const SET_INDICADORES_LOADING = (state, payload) => {
  state.indicadores.loading = payload
}

export const SET_QUESTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.questions.data = payload
    state.questions.lastUpdate = new Date()
  }
}
export const ADD_QUESTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.questions.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.questions.data.push(data)
      }
    })
  }
}
export const SET_QUESTIONS_LOADING = (state, payload) => {
  state.questions.loading = payload
}

// Mutations
export const SET_PERFORMANCE_MANAGEMENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.performanceManagement.data = payload
    state.performanceManagement.lastUpdate = new Date()
  }
}
export const ADD_PERFORMANCE_MANAGEMENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.performanceManagement.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.performanceManagement.data.push(data)
      }
    })
  }
}
export const SET_PERFORMANCE_MANAGEMENT_LOADING = (state, payload) => {
  state.performanceManagement.loading = payload
}

export const SET_FILTER_RH = (state, payload) => {
  state.filterRH = payload
}

export const SET_TASK_VALUATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.taskValuation.data = payload
    state.taskValuation.lastUpdate = new Date()
  }
}
export const ADD_TASK_VALUATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.taskValuation.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.taskValuation.data.push(data)
      }
    })
  }
}
export const SET_TASK_VALUATION_LOADING = (state, payload) => {
  state.taskValuation.loading = payload
}
export const SET_PROFESSIONAL_QUESTIONS_GOALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.professionalQuestionsGoals.data = payload
    state.professionalQuestionsGoals.lastUpdate = new Date()
  }
}
export const ADD_PROFESSIONAL_QUESTIONS_GOALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.professionalQuestionsGoals.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.professionalQuestionsGoals.data.push(data)
      }
    })
  }
}
export const SET_PROFESSIONAL_QUESTIONS_GOALS_LOADING = (state, payload) => {
  state.professionalQuestionsGoals.loading = payload
}

export const SET_COMMERCIAL_EFFORT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.commercialEffort.data = payload
    state.commercialEffort.lastUpdate = new Date()
  }
}
export const ADD_COMMERCIAL_EFFORT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.commercialEffort.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.commercialEffort.data.push(data)
      }
    })
  }
}
export const SET_COMMERCIAL_EFFORT_LOADING = (state, payload) => {
  state.commercialEffort.loading = payload
}

